import { useBranding } from '@/contexts/BrandingContext'
import { brandLook } from '@/theme/brands'

/**
 * Whether this host wears Joulelingo's gamey look: the character, chunky pressable buttons,
 * celebrations. On joulelingo.com only, and never on a partner host, where the partner's own
 * tone applies. Used by the marketing pages and by the pupil-facing app screens (the quiz);
 * the business manager's screens (costs, alerts, reports, admin) stay calm whatever this says.
 */
export default function useGamey() {
    const { brand } = useBranding()
    return Boolean(
        brand && !brand.is_partner && brandLook(brand.brand_key).playful
    )
}
